<template>
    <!-- <loading
      :active="
        isLoading_User ||
        isLoading_Influencer ||
        isLoading_Payment ||
        show_loading
      "
      :is-full-page="fullPage"
      color="#007BFF"
    /> -->
    <div class="py-4 container-fluid">
      <div class="mb-2">
        <button @click="$router.go(-1)" class="btn btn-light" :to="-1">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex">
                <div>
                  <div class="numbers">
                    <p class="mb-0 text-sm font-weight-bold">Line Name</p>
                    <h5 class="font-weight-bolder">
                      {{ user.line_display || "ไม่มีข้อมูล" }}
                    </h5>
                    <p class="mb-0 text-sm font-weight-bold">User Name</p>
                    <h5 class="font-weight-bolder">
                      {{ user.username || "ไม่มีข้อมูล" }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <card
            title="Code Current"
            :value="user.code_current ? user.code_current : '--'"
          ></card>
        </div>
  
        <div class="col-lg-4 col-md-6">
          <card title="Remaining Days" :value="user.remaining_day || '--'"></card>
        </div>
        <div class="col-lg-4 col-md-6">
          <!-- <card title="Expire Date" :value="user.expire_date ?? '--'"></card> -->
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex">
                <div>
                  <div class="numbers">
                    <p class="mb-0 text-sm font-weight-bold">Expire Date</p>
                    <h5 class="font-weight-bolder">
                      <div v-if="!edit_mode">
                        {{ dateToFormat(user.expire_date) }}
                        <i
                          @click="edit()"
                          class="fa fa-xs fa-pencil-alt pointer"
                        ></i>
                      </div>
                      <div v-if="edit_mode">
                        <input
                          type="date"
                          class="me-2"
                          name="expire_date"
                          v-model="input.expire_date"
                        />
                        <i
                          class="fa fa-xs fa-save pointer me-2"
                          @click="save_expire_date()"
                        ></i>
                        <i
                          class="fa fa-xs fa-times pointer"
                          @click="edit_mode = false"
                        ></i>
                      </div>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <card title="Point" :value="user.point || '--'"></card>
        </div>
        <div class="col-lg-4 col-md-6">
          <card title="Comission" :value="user.ref_commission || '--'"></card>
        </div>
        <div class="col-lg-4 col-md-6">
          <card title="DNA ID" :value="user.dna_id || '--'"></card>
        </div>
        <div class="col-lg-2 col-6">
          <card title="Ref. Username" :value="user.ref_username || '--'"></card>
        </div>
        <div class="col-lg-2 col-6">
          <card
            title="Ref. Line Display"
            :value="user.ref_line_display || '--'"
          ></card>
        </div>
  
        <div class="col-md-12 col-lg-4">
          <div class="row">
            <div class="col-6">
              <!-- <card
                title="Date of Birth"
                :value="`${user.b_date ?? '--'}/${user.b_month ?? '--'}/${
                  user.b_year ?? '--'
                }`"
                :cut_text="true"
              ></card> -->
              <div class="mb-4 card">
                <div class="p-3 card-body">
                  <div class="">
                    <div class="numbers">
                      <p class="mb-0 text-sm font-weight-bold">Birth Date</p>
  
                      <div v-if="!edit_mode_birth" class="">
                        <h5 class="font-weight-bolder">
                          {{ user.b_date ?? "--" }}/{{ user.b_month ?? "--" }}/{{
                            user.b_year ?? "--"
                          }}
                          <i
                            @click="edit_birth()"
                            class="fa fa-xs fa-pencil-alt pointer"
                          ></i>
                        </h5>
                      </div>
                      <div v-if="edit_mode_birth" class="">
                        <h5 class="d-flex font-weight-bolder align-items-center">
                          <input
                            type="date"
                            class="me-2"
                            name="birth_date"
                            v-model="input.birth_date"
                          />
                          <i
                            class="fa fa-xs fa-save pointer me-2"
                            @click="save_birth_date()"
                          ></i>
                          <i
                            class="fa fa-xs fa-times pointer"
                            @click="edit_mode_birth = false"
                          ></i>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <!-- <card
                title="Time of Birth"
                :value="`${user.b_hour ?? '--'}:${user.b_min ?? '--'}`"
              ></card> -->
              <div class="mb-4 card">
                <div class="p-3 card-body">
                  <div class="">
                    <div class="numbers">
                      <p class="mb-0 text-sm font-weight-bold">Time of Birth</p>
  
                      <div v-if="!edit_mode_birth" class="">
                        <h5 class="font-weight-bolder">
                          {{ user.b_hour ?? "--" }}:{{ user.b_min ?? "--" }}
                          <i
                            @click="edit_birth()"
                            class="fa fa-xs fa-pencil-alt pointer"
                          ></i>
                        </h5>
                      </div>
                      <div v-if="edit_mode_birth" class="">
                        <h5 class="d-flex font-weight-bolder align-items-center">
                          <input
                            type="time"
                            class="me-2"
                            name="birth_time"
                            v-model="input.birth_time"
                          />
                          <i
                            class="fa fa-xs fa-save pointer me-2"
                            @click="save_birth_date()"
                          ></i>
                          <i
                            class="fa fa-xs fa-times pointer"
                            @click="edit_mode_birth = false"
                          ></i>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- <card
            title="TEST"
            value="10"
            percentage="10"
            iconClass="ni ni-money-coinss"
            iconBackground="bg-gradient-primary"
            detail="Detail naja"
            directionReverse
          ></card> -->
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-2">
            <button
              type="button"
              class="btn me-2"
              :class="{ 'btn-primary': current_tab == 'Members' }"
              @click="setTab('Members')"
            >
              Members
            </button>
            <button
              type="button"
              class="btn me-2"
              :class="{ 'btn-primary': current_tab == 'Influencers' }"
              @click="setTab('Influencers')"
            >
              Influencers
            </button>
            <button
              type="button"
              class="btn"
              :class="{ 'btn-primary': current_tab == 'Payments' }"
              @click="setTab('Payments')"
            >
              Payments
            </button>
          </div>
          <datatable-members
            v-if="current_tab == 'Members'"
            :rows="rows_members"
            :columns="columns"
            :isLoading="isLoading_User"
          />
          <datatable-influencers
            v-if="current_tab == 'Influencers'"
            :rows="rows"
            :columns="columns"
            :isLoading="isLoading_Influencer"
          />
          <datatable-payments
            v-if="current_tab == 'Payments'"
            :rows="rows_payments"
            :columns="columns_payments"
            :isLoading="isLoading_Payment"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import swal from "sweetalert2";
  /* eslint-disable */
  // import AuthorsTable from "./components/AuthorsTable.vue";
  import DatatableInfluencers from "./components/DatatableInfluencers.vue";
  import DatatablePayments from "./components/DatatablePayments.vue";
  import DatatableMembers from "./components/DatatableMembers.vue";
  import Card from "@/examples/Cards/Card.vue";
  import moment from "moment";
  // import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/css/index.css";
  import axios from "axios";
  import qs from "qs";
  // import flatPickr from "vue-flatpickr-component";
  // import "flatpickr/dist/flatpickr.css";
  
  export default {
    name: "User_Detail",
    components: {
      DatatableInfluencers,
      DatatablePayments,
      DatatableMembers,
      Card,
      // Loading,
      // flatPickr,
    },
    data() {
      return {
        show_loading: false,
        current_tab: "Members",
        edit_mode: false,
        edit_mode_birth: false,
        input: {
          expire_date: null,
          birth_date: null,
          birth_time: null,
        },
        columns: [
          {
            label: "LINE DISPLAY/UID",
            field: "line_display",
          },
          {
            label: "Remaining Days",
            field: "remaining_day",
            type: "number",
          },
          {
            label: "Point",
            field: "point",
            type: "number",
          },
        ],
        columns_payments: [
          {
            label: "Request Date",
            field: "req_timestamp",
            type: "date",
            thClass: "text-start",
            tdClass: "text-start",
            dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
            dateOutputFormat: "dd/MM/yyyy",
          },
          {
            label: "Paid Date",
            field: "paid_timestamp",
            type: "date",
            thClass: "text-start",
            tdClass: "text-start",
            dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
            dateOutputFormat: "dd/MM/yyyy",
          },
          {
            label: "Amount",
            field: "amount",
            type: "decimal",
          },
          // {
          //   label: "Amount_Decimal",
          //   field: "amount_decimal",
          //   type: "number",
          // },
          {
            label: "Point",
            field: "ref_point",
            type: "decimal",
          },
        ],
      };
    },
    created() {
      var user = window.localStorage.getItem("$logged_user");
      // console.log("PARM")
      console.log(this.$route.params);
      // this.members = this.$route.params.members;
      if (user != "admin") {
        this.$router.push("/");
      }
  
      this.username = this.$route.params.username;
      this.getUser(this.username);
      // this.$store.dispatch("getUser", this.username);
    },
    watch: {
      // watch: {
      $route(to, from) {
        console.log("watch", {
          to,
          from,
          //   });
        });
        if (
          to.name == "user/detail" &&
          to.params.username != from.params.username
        ) {
          this.username = to.params.username;
          this.getUser(this.username);
        }
        //   this.username = this.$route.params.username;
        //   this.getUser(this.username);
  
        // this.$store.dispatch("getUser", this.username);
        // }
      },
    },
    methods: {
      format_date(value) {
        if (value) {
          return moment(String(value)).format("YYYY-MM-DD");
        }
        return value;
      },
      edit() {
        this.edit_mode = true;
        this.input.expire_date = this.format_date(this.user.expire_date);
      },
      edit_birth() {
        this.edit_mode_birth = true;
        const birth_date =
          this.user.b_year +
          "-" +
          this.user.b_month +
          "-" +
          this.user.b_date +
          " " +
          this.user.b_hour +
          ":" +
          this.user.b_min;
        this.input.birth_date = this.format_date(birth_date);
          this.input.birth_time = moment(birth_date).format("HH:mm");
      },
      setTab(tab) {
        this.current_tab = tab;
      },
      dateToFormat(date) {
        return moment(date).format("DD/MM/YYYY");
      },
      getUser(username) {
        // swal.showLoading();
        this.$store.dispatch("getUser", username);
        this.$store.dispatch("getInfluencers", username);
        this.$store.dispatch("getPayments", username);
      },
  
      save_expire_date() {
        axios
          .post(
            process.env.VUE_APP_User_Expire_Update,
            {
              username: this.user.username,
              expire_date: this.input.expire_date,
            },
            {
              headers: {
                //   Authorization: "Bearer " + window.localStorage.getItem("$token"),
              },
            }
          )
          .then((res) => {
            const data = res.data;
            console.log(res);
            if (data.status != "success") {
              swal.fire({
                title: "Error",
                text: "Unable to update expire date",
                icon: "error",
              });
              return;
            }
            swal.fire({
              title: "Success",
              text: "Update expire date success",
              icon: "success",
            }).then(() => {
                window.location.reload();
            //   this.getUser(this.username);
            });
            this.user.expire_date = this.input.expire_date;
            this.edit_mode = false;
            //   this.getUser(this.username);
          })
          .catch((err) => {
            console.log(err);
            swal.fire({
              title: "Error",
              text: "Update expire date error",
              icon: "error",
            });
          });
      },
      async save_birth_date() {
        console.log("save_birth_date", this.input.birth_date);
        const birth_date = this.input.birth_date;
        if(!moment(this.input.birth_date).isValid() ){return}
        var post_data = ({
          username: this.user.username,
          b_date: moment(birth_date).format("DD"),
          b_month: moment(birth_date).format("MM"),
          b_year: moment(birth_date).format("YYYY"),
          b_hour: moment(this.input.birth_time,'HH:mm').isValid() ?  moment(this.input.birth_time,'HH:mm').format('HH') : (this.user.b_hour || "00"),
          b_min: moment(this.input.birth_time,'HH:mm').isValid() ?  moment(this.input.birth_time,'HH:mm').format('mm') : (this.user.b_min || "00"),
          // b_min:  this.user.b_min || "00",
          is_birth_time: "1",
        });
        var config = {
          method: "post",
          url: "https://horo-pk.herokuapp.com/api/user/birth/update",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: qs.stringify(post_data),
        };
        //   const loading = this.show_loading;
        //   loading = true;
        this.show_loading = true;
        console.log("this/1", this);
        await axios(config)
          .then(response=> {
            //   this.show_loading = false;
            const data = response.data || {};
            console.log("data", data);
            //   console.log(JSON.stringify(response.data));
            if (data.status != "success") {
              swal.fire({
                title: "Error",
                text: "Unable to update birth date",
                icon: "error",
              });
              return;
            }
            console.log("this/2", this);
  
            this.edit_mode_birth = false;
        this.user.b_date = post_data.b_date;
          this.user.b_month = post_data.b_month;
          this.user.b_year = post_data.b_year;
          this.user.b_hour = post_data.b_hour;
          this.user.b_min = post_data.b_min;
          console.log('success',{
              post_data,
              user:this.user
          });
            swal.fire({
              title: "Success",
              text: "Update birth date success",
              icon: "success",
            }).then(() => {
                window.location.reload();
            //   this.getUser(this.username);
            });
            //
        //   window.location.reload();
          //   this.
            //   this.show_loading = true;
          })
          .catch(error=> {
            //   this.show_loading = false;
  
            console.log(error);
            swal.fire({
              title: "Error",
              text: "Update birth date error",
              icon: "error",
            });
          });
  
        this.show_loading = false;
      },
    },
    computed: {
      user() {
        const user = this.$store.state.user;
        const users = this.$store.state.users;
        const ref_user = users.find((u) => u.username == user.ref_username);
        if (!this.$store.state.isLoading_User) {
          swal.close();
        }
        console.log({ ref_user });
        return {
          ...user,
          ref_line_display: ref_user ? ref_user.line_display : "-",
          // expire_date: this.dateToFormat(user.expire_date),
        };
      },
      isLoading() {
        return this.$store.state.isLoading;
      },
      isLoading_User() {
        const isLoading_User = this.$store.state.isLoading_User;
        console.log({ isLoading_User });
        if (!isLoading_User) {
          // swal.close();
        } else {
          // swal.fire({
          //     title: "Loading...",
          //     allowOutsideClick: false,
          //     onBeforeOpen: () => {
          //     swal.showLoading();
          //     },
          // });
        }
        return isLoading_User;
      },
      isLoading_Influencer() {
        return this.$store.state.isLoading_Influencer;
      },
      isLoading_Payment() {
        return this.$store.state.isLoading_Payment;
      },
      rows() {
        return this.$store.state.influencers;
      },
      rows_payments() {
        return this.$store.state.payments;
      },
      rows_members() {
        return this.$store.state.user_members;
      },
    },
  };
  </script>
  